import css from 'styled-jsx/css';

export default css.global`@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic");
:root {
  --ci-primary-blue: #2f2e7c;
  --ci-primary-red: #b12429;
  --ci-primary-yellow: #fdb72b;
  --ci-secondary-blue: #007bff;
  --ci-secondary-yellow: #fdb72b;
  --ci-secondary-green: #33a354;
  --ci-secondary-pink: #ff9195;
  --ci-secondary-lilac: #7a7ef0;
  --ci-danger: #da1e27;
  --ci-warning: #ff7600;
  --ci-success: #33a354;
  --ci-interact: #007bff;
  --ci-black: #212429;
  --ci-grey-1: #495057;
  --ci-grey-2: #76808b;
  --ci-grey-3: #acb5bd;
  --ci-grey-4: #dde2e5;
  --ci-grey-5: #f0f3f5;
  --ci-white: #ffffff;
  --ci-primary-blue: #2f2e7c;
  --ci-primary-red: #b12429;
  --ci-primary-yellow: #fdb72b;
  --ci-secondary-blue: #007bff;
  --ci-secondary-yellow: #fdb72b;
  --ci-secondary-green: #33a354;
  --ci-secondary-pink: #ff9195;
  --ci-secondary-lilac: #7a7ef0;
  --ci-danger: #da1e27;
  --ci-warning: #ff7600;
  --ci-success: #33a354;
  --ci-interact: #007bff;
  font-family: "Open Sans", sans-serif;
  font-size: 16px; }

.ci-auth-navbar {
  position: fixed;
  width: 100%;
  height: 65px;
  background-color: #ffffff;
  border-bottom: 1px solid #dde2e5;
  display: flex;
  align-items: center;
  z-index: 1000;
  padding: 0 1rem; }
  @media (min-width: 1024px) {
    .ci-auth-navbar {
      padding: 0 1.8rem; } }
  .ci-auth-navbar .ci-sidenav-toggler {
    margin-right: auto;
    font-size: 1.25rem; }
    .ci-auth-navbar .ci-sidenav-toggler i {
      color: #212429; }
    @media (min-width: 1024px) {
      .ci-auth-navbar .ci-sidenav-toggler {
        display: none; } }
  .ci-auth-navbar .ci-logo-brand {
    display: flex; }
    .ci-auth-navbar .ci-logo-brand span {
      font-size: 1.5rem; }
      .ci-auth-navbar .ci-logo-brand span:first-child {
        color: #000000;
        font-weight: 500;
        }
      .ci-auth-navbar .ci-logo-brand span:last-child {
        color: #D32828;
        padding-left: 0.3rem;
        font-weight: 600;

        text-transform: capitalize; }
  .ci-auth-navbar .ci-nav {
    margin-left: auto; }
    .ci-auth-navbar .ci-nav .ci-navbar {
      list-style: none;
      margin-bottom: 0;
      padding: 0; }
      .ci-auth-navbar .ci-nav .ci-navbar .dropdown .dropdown-menu.auth-nav-menu {
        left: -121px; }
        @media (min-width: 1024px) {
          .ci-auth-navbar .ci-nav .ci-navbar .dropdown .dropdown-menu.auth-nav-menu {
            left: -62px; } }
      .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user {
        border-radius: 1.5rem;
        border: 1px solid #dde2e5;
        display: flex;
        align-items: center;
        padding: 0.4rem 0.6rem;
        color: #212429; }
        .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user span {
          padding: 0 0.3rem; }
          @media (min-width: 1024px) {
            .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user span {
              padding: 0 0.6rem; } }
        .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user span,
        .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user i {
          display: none; }
          @media (min-width: 1024px) {
            .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user span,
            .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user i {
              display: inline-block; } }
        .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user i {
          margin-top: -0.4rem; }
        .ci-auth-navbar .ci-nav .ci-navbar .ci-nav-user img {
          width: 20px; }

.ci-wrapper {
  background-color: #f0f3f5; }

.ci-main-content {
  padding-top: 65px;
  transition: all 100ms ease; }
  @media (min-width: 1024px) {
    .ci-main-content {
      margin-left: 270px; } }
  .ci-main-content_open {
    margin-left: 270px;
    width: 100vw; }
    @media (min-width: 768px) {
      .ci-main-content_open {
        width: unset; } }

.ci-sidebar-menu {
  list-style: none;
  padding: 0; }

.ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .ci-sidebar-submenu_link:hover, .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-menu_link:hover, .ci-sidebar-menu .active.ci-sidebar-menu_item .ci-sidebar-menu_link {
  background-color: #EFF6F3;
  font-weight: 600;
cursor: pointer;
}

.ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .ci-sidebar-submenu_link, .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-menu_link {
  color: #067d16;
  display: flex;
  align-items: center;
  font-size: 1rem -4px;
  font-weight: 500;
  padding: 0.6rem 1.3rem;
  transition: all 200ms ease; }
  .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .ci-sidebar-submenu_link img, .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-menu_link img {
    width: 20px;
    margin-right: 0.9rem; }
  .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .collapsed.ci-sidebar-submenu_link i.fa-angle-down, .ci-sidebar-menu .ci-sidebar-menu_item .collapsed.ci-sidebar-menu_link i.fa-angle-down {
    transform: rotate(0deg); }
  .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .ci-sidebar-submenu_link i.fa-angle-down, .ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-menu_link i.fa-angle-down {
    margin-left: auto;
    color: inherit;
    transform: rotate(180deg); }

.ci-sidebar-menu .ci-sidebar-menu_item {
  margin-bottom: 1rem; }

.ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu {
  background-color: #f0f3f5;
  display: flex;
  flex-direction: column;
  padding-left: 3rem; }

.ci-sidebar-menu .ci-sidebar-menu_item .ci-sidebar-submenu .ci-sidebar-submenu_link {
  font-size: 0.875rem; }

.ci-sidebar {
  position: fixed;
  margin-top: 78px;
  margin-left: 2rem;
  border-radius: 10px;
  overflow-x: hidden;
  background-color: #ffffff;
  transition: all 100ms ease-in-out;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  width: 0; }
  @media (min-width: 1024px) {
    .ci-sidebar {
      width: 240px; } }
  .ci-sidebar.ci-sidebar_open {
    width: 240px; }
  .ci-sidebar .ci-sidebar-content {
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    height: 100%; }
  .ci-sidebar .support-sect {
    padding: 1.2rem 1.4rem;
    margin-top: auto;
    margin-bottom: 2rem; }
    .ci-sidebar .support-sect img {
      width: 40px;
      margin-bottom: 0.5rem; }
    .ci-sidebar .support-sect p {
      color: #495057;
      font-size: 14px; }
    .ci-sidebar .support-sect a.cicod-btn {
      display: block;
      padding: 0.5rem 0.3rem; }

.ci-alert.error {
  background-color: #fef9f9;
  border-color: #c41b23;
  color: #ad181f;
  box-shadow: 0px 0px 10px #fbe2e4; }
  .ci-alert.error .ci-alert__close {
    color: #ad181f; }

.ci-alert.success {
  background-color: #effaf2;
  border-color: #2d904a;
  color: #277c40;
  box-shadow: 0px 0px 10px #ccefd7; }
  .ci-alert.success .ci-alert__close {
    color: #277c40; }

.ci-alert {
  border: 1px solid;
  border-color: #dde2e5;
  background-color: #ffffff;
  width: fit-content;
  max-width: 400%;
  border-radius: 5px;
  padding: 1rem;
  font-weight: 500;
  color: #212429;
  box-shadow: 0px 0px 10px #acb5bd; }
  .ci-alert .ci-alert__close {
    background: transparent;
    color: inherit;
    font-size: 0.875rem;
    position: absolute;
    top: 2px;
    right: 2px;
    border: none;
    border-radius: 50%;
    padding: 0 0.3rem;
    font-weight: 600; }
  .ci-alert a {
    color: inherit; }
  .ci-alert p {
    margin-bottom: 0; }

/*# sourceMappingURL=main.css.map */
`